import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "time-block-item-value" }
const _hoisted_2 = { class: "time-block-item-unit" }


export default /*@__PURE__*/_defineComponent({
  __name: 'time-part',
  props: {
    forcedMobile: Boolean,
    value: Number,
    unit: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['time-block-item', __props.forcedMobile ? 'forced-mobile' : ''])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.value?.toString() ?? "\u00a0"), 1 /* TEXT */),
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.unit ?? "\u00a0"), 1 /* TEXT */)
  ], 2 /* CLASS */))
}
}

})